export const VISIBLE_ITEMS_COUNT = 3;

export const MIN_SYMBOLS_TO_SEARCH = 1;
